import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import {
  LOCAL_STRIPE,
  LOCAL_STRIPE_URL,
  TICKET_PORTAL_URL,
  SITE_URL,
  TICKET_FOLDER,
} from "@constant";
import { priceDisplayLocally } from "@utilscommon";
import LocaleStrings from "@language";

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const location = useLocation();
  const { eventData, onlinePaymentKeys, currency, amount } = props;
  const [errormessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // console.log("eventData------- :- ", eventData);
  // console.log("onlinePaymentKeys :- ", onlinePaymentKeys);
  let param = location.search;
  // let param = new URLSearchParams(location.search);
  // param.set("ordernumber", onlinePaymentKeys?.ordernumber);
  // param = `?${param.toString()}`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setIsLoading(true);

    let callbackpath =
      onlinePaymentKeys.gateway === "eventify"
        ? "eventify_callback"
        : "stripe_callback";
    let redirect = `${LOCAL_STRIPE_URL}/${callbackpath}/${props?.stripeAccountId}${param}`;
    if (!LOCAL_STRIPE) {
      let eventSeoCode = eventData?.seocode;
      let hostname = window.location.hostname;

      let url = TICKET_PORTAL_URL.replace("{seocode}", eventSeoCode);
      if (!hostname.includes(SITE_URL)) {
        if (eventSeoCode.charAt(eventSeoCode.length - 1) === "/") {
          eventSeoCode = eventSeoCode.slice(0, -1);
        }
        url = `https://${eventSeoCode}${TICKET_FOLDER}`;
      }
      redirect = `${url}/${callbackpath}/${props?.stripeAccountId}${param}`;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: redirect,
      },
    });
    // console.log("error :- ", error);

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setErrorMessage(error.message);
    } else {
      setErrorMessage(LocaleStrings.kStripePaymentFailedText);
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
      {/* Show any error or success messages */}

      {errormessage && (
        <div className="payment-error-message" id="payment-error-message">
          {errormessage}
        </div>
      )}

      <div id="stripe-payment-form" className="stripe-payment-form">
        <PaymentElement id="payment-element" options={paymentElementOptions} />

        {stripe && elements ? (
          <button
            className="theme-button-md w-full mt-3"
            disabled={isLoading || !stripe || !elements}
            id="submit"
            type="button"
            onClick={handleSubmit}
          >
            <span id="button-text">
              {isLoading ? (
                <div className="p-1" id="spinner">
                  <svg
                    className={`${isLoading ? "" : "hidden"} cust-btn-spinner`}
                    viewBox="0 0 1024 1024"
                    focusable="false"
                    data-icon="btnloading"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                  </svg>
                </div>
              ) : (
                _.replace(
                  LocaleStrings.kPayAmountText,
                  "#amount",
                  `${currency} ${priceDisplayLocally(amount)}`
                )
              )}
            </span>
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
